import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    stages: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_STAGES_SELECT_IDS (store, ids) {
      store.stages.selectIds = ids
    },
    REMOVE_STAGE_SELECT_IDS (store, ids) {
      store.stages.selectIds = store.stages.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_STAGES_SELECT_ID (store, id) {
      store.stages.selectId = id
    },
    SET_STAGES_FILTERS (store, filters) {
      store.stages.filters = filters
    },
    SET_STAGES_PAGINATE (store, val) {
      store.stages.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getStages: (store, getters) => {
      return store.stages.selectIds.map((id) => {
        return getters['entities/stages/find'](id)
      })
    },
    getStagesFilters: (store, getters) => {
      return store.stages.filters
    },
    getStagesPaginate: (store, getters) => {
      return store.stages.paginate
    },
    getStage: (store, getters) => {
      return getters['entities/stages/find'](store.stages.selectId) || {}
    }
  },
  actions: {
    /*
    selectStages
    */
    selectStages ({commit, dispatch, getters, state}, filters) {
      return dispatch('getStages', filters)
      .then((response) => {
        commit('SET_STAGES_FILTERS', filters)
        commit('SET_STAGES_PAGINATE', response)
        commit('SET_STAGES_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectStages
    */
    refreshSelectStages ({commit, dispatch, getters, state}) {
      return dispatch('selectStages', getters.getStagesFilters)
    },
    /*
    selectStage
    */
    selectStage ({commit, dispatch, getters, state}, id) {
      return dispatch('getStageById', id)
      .then((response) => {
        commit('SET_STAGES_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getStages
    */
    getStages ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/stages`, {params: filters})
      .then((response) => {
        return dispatch('entities/stages/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.stages || []
      })
    },
    /*
    getStageById
    */
    getStageById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/stages/${id}`)
      .then((response) => {
        return dispatch('entities/stages/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.stages[0]
      })
    },
    /*
    createStage
    */
    createStage ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/stages`, data)
      .then((response) => {
        return dispatch('entities/stages/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.stages[0]
      })
    },
    /*
    updateStage
    */
    updateStage ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/stages/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/stages/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.stages[0]
      })
    },
    /*
    updateStageActions
    */
    updateStageActions ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/stages/${data._id}/actions`, data)
      .then((response) => {
        return dispatch('entities/stages/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.stages[0]
      })
    },
    /*
    deleteStage
    */
    deleteStage ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/stages/${id}`)
      .then((response) => {
        commit('REMOVE_STAGE_SELECT_IDS', [id])
        dispatch('entities/stages/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Stage.js